import type { ChatMessage } from '@/components/VisionAi/chat-panel-components/utils/VisionChatSidePanel.types';
import { ARTIFACT_MARKER_PATTERN } from '@/components/VisionAi/utils/message';
import type { VisionWidget, WidgetType } from '@/components/VisionAi/widgets/visionWidget.types';

const MEDIA_WIDGET_TYPES: ReadonlySet<WidgetType> = new Set([
  'library_media',
  'library_media_group',
]);

const ARTIFACT_MARKER_REGEX = new RegExp(ARTIFACT_MARKER_PATTERN, 'g');

export function unanchoredWidgets(message: ChatMessage): VisionWidget[] {
  const widgets = message.widgets ?? [];
  if (!widgets.length) return [];

  const referencedIds = new Set(
    Array.from((message.text ?? '').matchAll(ARTIFACT_MARKER_REGEX), (match) => match[1]),
  );

  // Dedupe when LLM includes two different widgets for the same media items (grouped + individual)
  const hasInlineMedia = widgets.some(
    (widget) =>
      MEDIA_WIDGET_TYPES.has(widget.type) && widget.id != null && referencedIds.has(widget.id),
  );

  return widgets.filter(
    (widget) =>
      !(widget.id && referencedIds.has(widget.id)) &&
      !(hasInlineMedia && MEDIA_WIDGET_TYPES.has(widget.type)),
  );
}
